/** Orange accent icons matching the restaurant detail mockup. */

const iconProps = {
  width: 30,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IconClock() {
  return (
    <svg {...iconProps} className="rdp-detail-svg">
      <circle cx="12" cy="12" r="9" {...stroke} />
      <path d="M12 7v5l3 2" {...stroke} />
    </svg>
  );
}

export function IconGlobe() {
  return (
    <svg {...iconProps} className="rdp-detail-svg">
      <circle cx="12" cy="12" r="9" {...stroke} />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" {...stroke} />
    </svg>
  );
}

export function IconStorefront() {
  return (
    <svg {...iconProps} className="rdp-detail-svg">
      <path d="M4 10h16v11H4zM6 10l2-5h8l2 5M9 21v-6h6v6" {...stroke} />
    </svg>
  );
}
